import { Result, type ResultProps } from "./Result";

export function ResultEmpty(props: ResultProps) {
  return (
    <Result
      icon="search"
      subTitle="Por favor, revisa el término de búsqueda."
      title="No se encontraron resultados"
      {...props}
    />
  );
}
